var serviceCentreSearch = function () {
	$(function() {

		$("#location-search-form").submit(function (e) {
			$("#serviceCentreLoader").show();
			e.preventDefault();
		});
		$("#serviceCentreSearchAction").click(function () {

			$("#locationSearchResultsModalContent").html("");

			$.ajax({
				type: "POST",
				url: "/umbraco/surface/servicecentre/search",
				data: {
					filter: $("#stores-search").val()
				},
				success: function(data) {
					if (data.result === "1") {
						$("#serviceCentreLoader").hide();
						$("#locationSearchResultsModalContent").html(data.viewHtml);
					} else {
						$("#serviceCentreLoader").hide();
					}
				},
				error: function () {
					$("#serviceCentreLoader").hide();
					alert("An error has occured while searching. Please try again.");
				}
			});
		});
	});
}

module.exports = serviceCentreSearch;